var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isEmpty } from 'lodash';
import { API } from 'globals/api';
import { LOCATION_END_POINTS } from 'globals/apiEndPoints';
import { APIMethod, LocationStatus } from 'globals/enums';
import { getTimestamp } from 'globals/global.functions';
import moment from 'moment';
import { DATE_FORMAT } from 'globals/global.constants';
var locationAPIAlarmType = {
    home: 'enter',
    away: 'exit',
};
export function getSeniorLocationService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: LOCATION_END_POINTS.GET_LOCATION,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, mapSeniorLocationData(response.data)];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
var mapSeniorLocationData = function (response) {
    var _a;
    var latest = response.latest, history = response.history, total_time_away_secs = response.total_time_away_secs;
    var currentLocationData = latest === null || latest === void 0 ? void 0 : latest.data;
    var locationData = {
        atHome: LocationStatus.NO_LOCATION,
        currentCoordinates: {
            latitude: null,
            longitude: null,
            timestamp: null,
            locationSource: null,
        },
        timeAwayFromHome: total_time_away_secs || 0,
        lastUpdated: 0,
        historyData: [],
    };
    if (!isEmpty(currentLocationData)) {
        locationData.atHome =
            (currentLocationData === null || currentLocationData === void 0 ? void 0 : currentLocationData.alarm_type) === locationAPIAlarmType.home
                ? LocationStatus.HOME
                : LocationStatus.AWAY;
        locationData.currentCoordinates = {
            latitude: currentLocationData.lat || null,
            longitude: currentLocationData.lng || null,
            timestamp: currentLocationData.time || null,
            locationSource: currentLocationData.locationSource || null,
        };
        locationData.lastUpdated = getTimestamp(currentLocationData.time || 0);
    }
    if (((_a = history === null || history === void 0 ? void 0 : history.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        history.data.forEach(function (historyData) {
            if (historyData.lat != null || historyData.lng != null) {
                locationData.historyData.push({
                    latitude: historyData.lat,
                    longitude: historyData.lng,
                    timestamp: getTimestamp(historyData.time),
                    locationSource: historyData.locationSource,
                    is_sos: historyData.is_sos,
                    is_fall: historyData.is_fall
                });
            }
        });
    }
    return locationData;
};
export function getSeniorLocationPostAPIService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API({
                        url: LOCATION_END_POINTS.POST_LOCATION,
                        method: APIMethod.Post,
                        data: params,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response === null || response === void 0 ? void 0 : response.applicationCode];
            }
        });
    });
}
export var createLocationData = function (data) {
    return {
        seniorId: data.senior_id,
    };
};
export function getSeniorLocationHistoryService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: LOCATION_END_POINTS.GET_ENABLE_DATES,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, monthEnableDatesData(response.data, params === null || params === void 0 ? void 0 : params.timezone)];
                case 2:
                    error_2 = _a.sent();
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    });
}
var monthEnableDatesData = function (response, timeZone) {
    var monthsEnableData = response.data;
    var lastRecordedDate = response.last_recorded_data;
    var nextRecordedDate = response.next_recorded_data;
    var current = moment.tz(timeZone);
    var calenderDates = monthsEnableData
        .filter(function (date) {
        return moment.tz(date, DATE_FORMAT, timeZone).isSameOrBefore(current, 'day');
    })
        .map(function (date) { return date.replaceAll('-', '/'); });
    lastRecordedDate = lastRecordedDate && lastRecordedDate.replaceAll('-', '/');
    nextRecordedDate = nextRecordedDate && nextRecordedDate.replaceAll('-', '/');
    return { calenderDates: calenderDates, lastRecordedDate: lastRecordedDate, nextRecordedDate: nextRecordedDate };
};
